import { ThemeProvider, createTheme } from '@mui/material/styles';
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import Routes from '../../routes'
import CustomSnackbar from 'components/custom_snackbar';
import { ConfigProvider } from 'antd';
import faIR from 'antd/lib/locale/fa_IR';
function App() {
  const theme = createTheme({
    direction: 'rtl',
    typography: {
      fontFamily: 'Vazir'
    }
  });

  // Create rtl cache
  const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [rtlPlugin],
  });

  return (
    <ConfigProvider locale={faIR}>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={theme}>
          <Routes />
          <CustomSnackbar />
        </ThemeProvider>
      </CacheProvider>
    </ConfigProvider>
  );
}

export default App;
